<template>
  <div id="member-details" class="professional-member-details">
    <v-card class="member-details-card" elevation="3">
      <!-- Professional Header Section -->
      <v-card-title class="member-card-header">
        <div class="header-content-single-row">
          <!-- Title Section -->
          <div class="title-section">
            <v-icon size="20" color="white" class="mr-2">mdi-account-circle</v-icon>
            <h3 class="member-card-title">{{ cardTitle }}</h3>
          </div>
          
          <!-- Status Badges Section -->
          <div class="status-badges-inline">
            <!-- Profile Status -->
            <v-chip
              v-if="Member.photo_flag == false"
              color="#ff5252"
              text-color="white"
              x-small
              class="status-chip-inline mr-2"
            >
              <v-icon left size="12">mdi-alert-circle</v-icon>
              Profile Incomplete
            </v-chip>
            <v-chip
              v-else
              color="#4caf50"
              text-color="white"
              x-small
              class="status-chip-inline mr-2"
            >
              <v-icon left size="12">mdi-check-circle</v-icon>
              Profile Complete
            </v-chip>
            
            <!-- Document Status -->
            <v-chip
              v-if="Member.document_flag == false"
              color="#ff9800"
              text-color="white"
              x-small
              class="status-chip-inline"
            >
              <v-icon left size="12">mdi-file-alert</v-icon>
              Age Proof Pending
            </v-chip>
            <v-chip
              v-else
              color="#4caf50"
              text-color="white"
              x-small
              class="status-chip-inline"
            >
              <v-icon left size="12">mdi-check-circle</v-icon>
              Age Proof Verified
            </v-chip>
          </div>
        </div>
      </v-card-title>      <!-- Professional Content Section -->
      <v-card-text class="member-card-content pa-4">
        <v-row class="member-info-row" align="center">
          <!-- Professional Avatar Section -->
          <v-col cols="12" sm="4" md="3" class="avatar-section text-center">
            <div class="avatar-container">
              <v-avatar
                size="100"
                class="member-avatar elevation-4"
                v-if="Member.photo && Member.photo !== ''"
              >
                <v-img
                  :src="Member.photo"
                  :alt="Member.member_name"
                  class="avatar-image"
                ></v-img>
              </v-avatar>
              <v-avatar
                v-else
                size="100"
                color="#e3f2fd"
                class="member-avatar elevation-4"
              >
                <v-icon size="50" color="#1976d2">mdi-account</v-icon>
              </v-avatar>
              <!-- <div class="avatar-label mt-2">
                <small class="text-muted">Member Photo</small>
              </div> -->
            </div>
          </v-col>

          <!-- Professional Details Section -->
          <v-col cols="12" sm="8" md="9" class="details-section">
            <v-row class="member-details-grid">

              <v-col cols="12" md="6" class="detail-item">
                <div class="detail-card">
                  <div class="detail-content">
                    <div class="detail-header">
                      <v-icon size="16" color="#1976d2" class="detail-icon-inline">mdi-account</v-icon>
                      <span class="detail-label">Full Name</span>
                    </div>
                    <div class="detail-value member-name">{{ Member.member_name || 'N/A' }}</div>
                  </div>
                </div>
              </v-col>

              <v-col cols="12" md="6" class="detail-item">
                <div class="detail-card">
                  <div class="detail-content">
                    <div class="detail-header">
                      <v-icon size="16" color="#1976d2" class="detail-icon-inline">mdi-account-box</v-icon>
                      <span class="detail-label">Membership ID</span>
                    </div>
                    <div class="detail-value member-name">{{ Member.membership_id || 'N/A' }}</div>
                  </div>
                </div>
              </v-col>

              <v-col cols="12" md="6" class="detail-item">
                <div class="detail-card">
                  <div class="detail-content">
                    <div class="detail-header">
                      <v-icon size="16" color="#1976d2" class="detail-icon-inline">mdi-email</v-icon>
                      <span class="detail-label">Email Address</span>
                    </div>
                    <div class="detail-value email-text">{{ Member.email_id || 'N/A' }}</div>
                  </div>
                </div>
              </v-col>

              <v-col cols="12" md="6" class="detail-item">
                <div class="detail-card">
                  <div class="detail-content">
                    <div class="detail-header">
                      <v-icon size="16" color="#1976d2" class="detail-icon-inline">mdi-phone</v-icon>
                      <span class="detail-label">Mobile Number</span>
                    </div>
                    <div class="detail-value">{{ Member.mobile_no || 'N/A' }}</div>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import common from "@/view/Common.vue";
import companyConfig from "@/company_config.json";
import Swal from "sweetalert2";
import MemberDetails from "@/view/pages/erp/jci-award/zonecon/common/MemberDetails.vue";
import AnswerAttachmentCreate from "@/view/pages/erp/jci-award/zonecon/common/AnswerAttachmentCreate.vue";

export default {
  mixins: [common],
  components: { AnswerAttachmentCreate, MemberDetails, VueEditor },
  props: {
    cardTitle: {
      required: true,
      type: String,
    },
    Member: {
      required: true,
    },
  },
  data() {
    return {
      valid1: true,
      search: "",
      ProgessStart: 0,
      uploadPercentage: 0,

      alert: {},

      valid: true,

      SubmitFlag: false,
      RecordFlag: false,
      ResultFlag: false,
      LoadingFlag: false,
      ComingSoonFlag: false,

      row: {},

      RoleId: 0,
      PageInfo: {},
      PageTitle: "",
      PageDescription: "",
      CurrentYearId: 0,
      YearName: "",
      NextYearCode: "",
      NextYearName: "",
      FloatingButtonOptions: {},
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    refreshPageData() {
      console.log("refreshPageData called");

      console.log("Member = ", this.Member);
    },
  },
  beforeMount() {
    var RoleId = this.$session.get("RoleId");
    RoleId = RoleId == (null || undefined) ? "" : RoleId;
    console.log({ RoleId });
    this.RoleId = RoleId;

    this.refreshPageData();
  },
};
</script>

<style lang="scss" scoped>
.professional-member-details {
  .member-details-card {
    border-radius: 12px;
    overflow: hidden;
    transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
    border: 1px solid rgba(0, 0, 0, 0.08);

    &:hover {
      box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
      transform: translateY(-2px);
    }

    .member-card-header {
      background: linear-gradient(135deg, #1976d2 0%, #1565c0 100%);
      color: white;
      padding: 16px 24px;
      border-bottom: none;

      .header-content-single-row {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        gap: 16px;

        .title-section {
          display: flex;
          align-items: center;
          flex: 1;
          min-width: 0;

          .member-card-title {
            font-size: 1.1rem;
            font-weight: 600;
            margin: 0;
            color: white;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .status-badges-inline {
          display: flex;
          align-items: center;
          gap: 8px;
          flex-wrap: nowrap;

          .status-chip-inline {
            font-weight: 500;
            font-size: 0.7rem;
            border-radius: 12px;
            transition: all 0.2s ease;
            white-space: nowrap;

            &:hover {
              transform: scale(1.05);
            }
          }
        }
      }
    }

    .member-card-content {
      background: #fafafa;
      min-height: 160px;

      .member-info-row {
        margin: 0;

        .avatar-section {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          padding: 16px;

          .avatar-container {
            .member-avatar {
              border: 4px solid white;
              box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
              transition: all 0.3s ease;

              &:hover {
                transform: scale(1.05);
                box-shadow: 0 6px 20px rgba(0, 0, 0, 0.2);
              }

              .avatar-image {
                object-fit: cover;
              }
            }

            .avatar-label {
              font-size: 0.875rem;
              font-weight: 500;
              color: #666;
            }
          }
        }

        .details-section {
          .member-details-grid {
            margin: 0;

            .detail-item {
              padding: 8px;

              .detail-card {
                background: white;
                padding: 16px 18px;
                border-radius: 8px;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
                border: 1px solid rgba(0, 0, 0, 0.06);
                height: 100%;
                min-height: 90px; // Increased to accommodate longer names
                transition: all 0.2s ease;

                &:hover {
                  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
                  transform: translateY(-1px);
                  border-color: #1976d2;
                }

                .detail-content {
                  .detail-header {
                    display: flex;
                    align-items: center;
                    gap: 6px;
                    margin-bottom: 6px;

                    .detail-icon-inline {
                      flex-shrink: 0;
                    }

                    .detail-label {
                      font-size: 0.7rem;
                      font-weight: 600;
                      color: #666;
                      text-transform: uppercase;
                      letter-spacing: 0.3px;
                      margin: 0;
                    }
                  }

                  .detail-value {
                    font-size: 0.9rem;
                    font-weight: 500;
                    color: #333;
                    word-break: break-word;
                    margin-left: 22px; // Reduced margin for better space utilization
                    line-height: 1.3;
                    min-height: 18px;

                    &.member-name {
                      font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
                      font-weight: 700;
                      color: #1a202c;
                      font-size: 0.95rem;
                      margin-left: 22px;
                      white-space: normal; // Allow wrapping for better visibility
                      overflow: visible;
                      text-overflow: initial;
                      max-width: 100%;
                      line-height: 1.25;
                      word-break: break-word;
                    }

                    &.email-text {
                      color: #1976d2;
                      text-decoration: none;
                      
                      &:hover {
                        text-decoration: underline;
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  // Responsive Design
  @media (max-width: 768px) {
    .member-details-card {
      .member-card-header {
        padding: 14px 20px;

        .header-content-single-row {
          flex-direction: column;
          align-items: flex-start;
          gap: 12px;

          .title-section {
            .member-card-title {
              font-size: 1rem;
              white-space: normal;
            }
          }

          .status-badges-inline {
            align-self: stretch;
            justify-content: flex-start;
            flex-wrap: wrap;
          }
        }
      }

      .member-card-content {
        .avatar-section {
          padding: 20px 16px;

          .avatar-container .member-avatar {
            width: 80px;
            height: 80px;
          }
        }

        .details-section {
          .member-details-grid .detail-item .detail-card {
            padding: 14px 16px;
            min-height: 85px;

            .detail-content .detail-value {
              margin-left: 20px; // Adjust for smaller screens
              font-size: 0.85rem;
              
              &.member-name {
                font-size: 0.9rem;
                margin-left: 20px;
                white-space: normal; // Allow wrapping on tablets
                overflow: visible;
                text-overflow: initial;
              }
            }
          }
        }
      }
    }
  }

  @media (max-width: 480px) {
    .member-details-card {
      .member-card-header {
        padding: 12px 16px;

        .header-content-single-row {
          .title-section {
            .member-card-title {
              font-size: 0.95rem;
            }
          }

          .status-badges-inline {
            .status-chip-inline {
              font-size: 0.65rem;
            }
          }
        }
      }

      .member-card-content {
        .details-section {
          .member-details-grid .detail-item {
            padding: 6px;

            .detail-card {
              padding: 12px 14px;
              min-height: 80px;

              .detail-content .detail-value {
                margin-left: 18px; // Further adjust for mobile
                font-size: 0.85rem;
                
                &.member-name {
                  font-size: 0.9rem;
                  margin-left: 18px;
                  white-space: normal; // Allow wrapping on mobile
                  overflow: visible;
                  text-overflow: initial;
                }
              }
            }
          }
        }
      }
    }
  }
}

// Dark theme support
.v-application.theme--dark {
  .professional-member-details {
    .member-details-card {
      background: #2d2d2d;
      border-color: rgba(255, 255, 255, 0.12);

      .member-card-content {
        background: #2d2d2d;

        .detail-item .detail-card {
          background: #404040;
          border-color: rgba(255, 255, 255, 0.12);

          &:hover {
            border-color: #1976d2;
          }

          .detail-content {
            .detail-label {
              color: #bbb;
            }

            .detail-value {
              color: #fff;

              &.email-text {
                color: #64b5f6;
              }
            }
          }
        }
      }
    }
  }
}
</style>
